import { ReactNode } from 'react';

import { DropdownMenuSeparator, DropdownMenuTitle } from 'components/Blocks';

import { TaskOptionItem } from './Option';
import { TaskOption } from './createTaskOptions';

/**
 * We do different than <ProjectOptionGroup /> because
 * for the task we actually have a Guard prior that checks every available option already
 */

interface Props {
  options: TaskOption[];
  title?: ReactNode;

  addDivisor?: boolean;

  taskId: string;
}

export function TaskOptionGroup({ options, taskId, addDivisor, title }: Props) {
  if (!options.length) return null;

  return (
    <>
      {addDivisor && <DropdownMenuSeparator />}

      {title && <DropdownMenuTitle>{title}</DropdownMenuTitle>}

      {options.map((option) => (
        <TaskOptionItem key={option} option={option} taskId={taskId} />
      ))}
    </>
  );
}
